import { deleteCookie, getCookie, setCookie } from './cookies';

const ACCESS = 'accessToken';
const REFRESH = 'sellerRefreshToken';
const PENDING = 'sellerPending';
const SELLER_NAME = 'sellerName';
const PENDING_CREDS = 'sellerPendingCreds';

export function getSellerAccessToken(): string | undefined {
  return getCookie(ACCESS);
}

export function getSellerRefreshToken(): string | undefined {
  return getCookie(REFRESH);
}

export function isSellerPending(): boolean {
  return getCookie(PENDING) === '1';
}

export function getSellerDisplayName(): string | undefined {
  return getCookie(SELLER_NAME);
}

export function setSellerSession(params: {
  accessToken: string;
  refreshToken: string;
  name?: string;
}) {
  setCookie(ACCESS, params.accessToken, 7);
  setCookie(REFRESH, params.refreshToken, 30);
  deleteCookie(PENDING);
  clearPendingCredentials();
  if (params.name) {
    setCookie(SELLER_NAME, params.name, 30);
  }
}

export function markSellerPending(name?: string) {
  deleteCookie(ACCESS);
  deleteCookie(REFRESH);
  setCookie(PENDING, '1', 30);
  if (name) {
    setCookie(SELLER_NAME, name, 30);
  }
}

export function setPendingCredentials(username: string, password: string) {
  try {
    sessionStorage.setItem(PENDING_CREDS, JSON.stringify({ username, password }));
  } catch {
    // ignore quota / private mode
  }
  markSellerPending(username);
}

export function getPendingCredentials(): { username: string; password: string } | null {
  try {
    const raw = sessionStorage.getItem(PENDING_CREDS);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { username?: string; password?: string };
    if (!parsed.username || !parsed.password) return null;
    return { username: parsed.username, password: parsed.password };
  } catch {
    return null;
  }
}

export function clearPendingCredentials() {
  try {
    sessionStorage.removeItem(PENDING_CREDS);
  } catch {
    // ignore
  }
}

export function clearSellerSession() {
  deleteCookie(ACCESS);
  deleteCookie(REFRESH);
  deleteCookie(PENDING);
  deleteCookie(SELLER_NAME);
  clearPendingCredentials();
}

export type SellerGate =
  | { kind: 'auth' }
  | { kind: 'pending' }
  | { kind: 'ready' };

export function getSellerGate(): SellerGate {
  if (getSellerAccessToken()) return { kind: 'ready' };
  if (isSellerPending()) return { kind: 'pending' };
  return { kind: 'auth' };
}
